import { Component, ReactNode, Fragment } from "react"

export interface NotificationBannerItem {
    message: ReactNode
}

export class NotificationBanner extends Component<
    object,
    { banner: NotificationBannerItem | undefined }
> {
    static instance: NotificationBanner

    constructor(props: object) {
        super(props)
        this.state = {
            banner: undefined,
        }
        NotificationBanner.instance = this
    }

    static clear = () => {
        NotificationBanner.instance.setState({
            banner: undefined,
        })
    }

    static notify = (banner: NotificationBannerItem) => {
        NotificationBanner.instance.setState({
            banner,
        })
    }

    render() {
        return (
            <Fragment>
                {this.state.banner?.message !== undefined && (
                    <div className="notification-banner__wrapper">{this.state.banner?.message}</div>
                )}
            </Fragment>
        )
    }
}
